import './styles/footer.css'

/**
 * Component representing the footer section of the application.
 * @returns {JSX.Element} The Footer component.
 */
export default function Footer({fadeOut}) {
    return (
        <footer className={`${fadeOut ? "fade-out" : ""}`}>
            <h1>Arthur Bordet</h1>
            <p>Voici mes réseaux pour suivre mes projets ou bien me contacter. <br /> À très bientôt je l'espère !</p>
            <div className="socials">
                <div className="cursor-detect-hover">
                    <a href="https://github.com/VoidSplit" target='_blank' rel='noreferrer' className="link cursor-hoverable">
                        Github
                    </a>
                </div>
                <div className="cursor-detect-hover">
                    <a href="https://www.npmjs.com/~voidsplit" target='_blank' rel='noreferrer' className="link cursor-hoverable">
                        Npm
                    </a>
                </div>
                <div className="cursor-detect-hover">
                    <a href="https://www.linkedin.com/in/arthur-bordet" target='_blank' rel='noreferrer' className="link cursor-hoverable">
                        LinkedIn
                    </a>
                </div>
                <div className="cursor-detect-hover">
                    <div onClick={() => {
                        navigator.clipboard.writeText("arthur-bordet@gmail.com")
                    }} className="link cursor-hoverable">
                        Email : arthur-bordet@gmail.com
                    </div>
                </div>
            </div>
            <div className="copyright">
                <span>Copyright ©2023</span>
                <strong>Bordet Arthur</strong>
                <span>| Designed By</span>
                <strong>Bordet Arthur</strong>
            </div>
        </footer>
    );
};